/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_3_QuestionInputs */

const en_svc_integration_faq_3_question = /** @type {(inputs: Svc_Integration_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate is AI data extraction?`)
};

const lv_svc_integration_faq_3_question = /** @type {(inputs: Svc_Integration_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cik precīza ir AI datu ieguve?`)
};

/**
* | output |
* | --- |
* | "How accurate is AI data extraction?" |
*
* @param {Svc_Integration_Faq_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_3_question = /** @type {((inputs?: Svc_Integration_Faq_3_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_3_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_3_question(inputs)
	return en_svc_integration_faq_3_question(inputs)
});